<template>
    <InvoicesList/>
</template>

<script>
import InvoicesList from '../../components/invoices/InvoicesList';

export default {
  components: {
    InvoicesList,
  },
};
</script>
